exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-PriceOld {\n  color: #ea0100; }\n\n.a-PriceOld--price {\n  text-decoration: line-through; }\n\n.a-PriceOld--color-inherit {\n  color: inherit; }\n\n.a-PriceOld--no-line-through {\n  text-decoration: none; }\n", ""]);

// exports
